"use client"

import { ConfigProvider, Input, Modal } from "antd"
import clsx from "clsx"
import { useEffect, useRef, useState } from "react"

const RedeemAmazonOrderModal = (props) => {
  const { open, onCancel, onOk, confirmLoading } = props
  const [orderNumber, setOrderNumber] = useState("")
  const [showErrTip, setShowErrTip] = useState(false)
  const inputRef = useRef()

  useEffect(() => {
    if (open) {
      setOrderNumber("")
      setTimeout(() => {
        inputRef.current.focus()
      }, 0)
    }
  }, [open])

  const handleOk = () => {
    const amazonOrderNumber = orderNumber.trim()

    if (!amazonOrderNumber) {
      return
    }

    onOk(amazonOrderNumber)
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 0,
        },
      }}
    >
      <Modal
        open={open}
        width={800}
        footer={null}
        className={clsx(
          "lg_[&_.ant-modal-content]_px-[22px] lg_[&_.ant-modal-content]_py-[60px]",
          "[&_.ant-modal-content]_px-3 [&_.ant-modal-content]_py-8"
        )}
        centered
        onCancel={onCancel}
      >
        <div className="flex flex-col items-center">
          <h2 className="font-poppins text-lg font-normal leading-[30px] text-primary lg_text-xl">
            ARE YOU SURE TO REDEEM THE POINTS?
          </h2>
          <ConfigProvider
            theme={{
              token: {
                borderRadius: 0,
                colorPrimary: "#2F6132",
              },
              components: {
                Input: {
                  activeShadow: "none",
                },
              },
            }}
          >
            <Input
              className={clsx(
                "mx-auto mt-4 h-[50px] max-w-[486px] lg_mt-[30px]",
                "text-[18px] font-semibold leading-[30px] text-primary"
              )}
              value={orderNumber}
              onChange={(e) => {
                setOrderNumber(e.target.value)
              }}
              placeholder="Enter Your Amazon Order Number..."
              ref={inputRef}
              onBlur={() => {
                setShowErrTip(!orderNumber.trim())
              }}
            />
            <div
              className={clsx(
                "hidden text-xs leading-[19px] text-[#e82f2f]",
                showErrTip && "block"
              )}
            >
              This field is required.
            </div>
          </ConfigProvider>

          <div
            className={clsx(
              "mt-6 flex w-full items-center justify-center lg_mt-[50px]",
              "flex-col sm_flex-row"
            )}
          >
            <button
              className={clsx(
                "h-[50px] w-full lg_h-[60px] lg_w-[200px]",
                "flex items-center justify-center",
                "bg-primary font-poppins text-sm font-normal leading-5 text-white active_scale-[.97] disabled_scale-100 lg_text-base"
              )}
              disabled={confirmLoading}
              onClick={handleOk}
            >
              {confirmLoading ? "CONFIRM..." : "CONFIRM"}
            </button>

            <button
              className={clsx(
                " mt-4 h-[50px] w-full sm_ml-20 sm_mt-0 lg_h-[60px] lg_w-[200px]",
                "flex items-center justify-center",
                " bg-white font-poppins text-sm font-normal leading-5 text-primary active_scale-[.97] lg_text-base",
                "border-2 border-solid border-primary"
              )}
              onClick={onCancel}
            >
              CANCEL
            </button>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  )
}

export default RedeemAmazonOrderModal
